import React, { useCallback } from "react";
import { StyleSheet, View, FlatList } from "react-native";
import HeaderWithBackAndTitle from "@components/HeaderWithBackAndTitle";
import t from "@constants/localization";
import { useDispatch, useSelector } from "react-redux";
import { SummaryTransaction } from "./responseInterfaces";
import { actions as walletActions } from "@reducers/walletReducer";
import WalletFilters from "./components/WalletFilter";
import { useFocusEffect } from "@react-navigation/native";
import LoadingModal from "@components/ModalLoader";
import GullakCard from "./components/GullakCard";
import TransactionCard from "./components/TransactionCard";
import SkeletonLoaderList from "@components/SkeletonLoaderList";
import { WalletTxnType } from "./utils";

const PATH = "screens/Wallet/Landing";
interface WalletProps {
  navigation: any;
  route: any;
}

const Wallet: React.FC<WalletProps> = ({ navigation, route }) => {
  const dispatch = useDispatch();
  const { walletSummary, isLoading } = useSelector(
    (state) => state.walletReducer,
  );

  useFocusEffect(
    useCallback(() => {
      dispatch(walletActions.getWalletMetaData());
      dispatch(walletActions.setWalletTxnType(WalletTxnType.ALL));
      dispatch(walletActions.getWalletSummary());
    }, [dispatch]),
  );

  const handlePressListItem = (item: SummaryTransaction) => {
    if (item.nav_to === "AGG") {
      dispatch(walletActions.setWalletTxnType(item.key));
      navigation.navigate("AggTransactionsView", { transactionType: item.key });
    } else {
      dispatch(walletActions.resetWalletTransactionsData());
      dispatch(walletActions.setTransactionType(item.key));
      navigation.navigate("TransactionsView");
    }
  };
  const handlePressWithdrawMoney = () => {
    navigation.navigate("WithDrawGullakMoney");
  };

  const handleApplyFilter = () => {
    dispatch(walletActions.getWalletSummary());
  };

  const renderItem = ({ item }) => (
    <TransactionCard item={item} onPress={() => handlePressListItem(item)} />
  );
  return (
    <>
      <HeaderWithBackAndTitle
        route={route}
        navigation={navigation}
        headertitle={t(`${PATH}/wallet`)}
        subHeaderTitle={undefined}
        headerStyle={undefined}
        rightIcon={undefined}
        RightButton={undefined}
        goingBackHandler={undefined}
        IsRightIconDropDown={undefined}
        hideShadow={true}
      />
      {isLoading ? (
        <SkeletonLoaderList length={8} marginHorizontal={16} />
      ) : (
        <View style={styles.container}>
          <GullakCard
            summary={walletSummary?.summary}
            onPress={handlePressWithdrawMoney}
          />
          <WalletFilters onApplyFilter={handleApplyFilter} />
          <FlatList
            data={walletSummary?.transactions}
            keyExtractor={(item) => item.key}
            renderItem={renderItem}
          />
        </View>
      )}
      <LoadingModal loading={isLoading} />
    </>
  );
};

export default Wallet;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginVertical: 16,
  },
});
